"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressMatchPostRequest$ = exports.AddressMatchPostRequest$outboundSchema = exports.AddressMatchPostRequest$inboundSchema = exports.Options$ = exports.Options$outboundSchema = exports.Options$inboundSchema = void 0;
exports.optionsToJSON = optionsToJSON;
exports.optionsFromJSON = optionsFromJSON;
exports.addressMatchPostRequestToJSON = addressMatchPostRequestToJSON;
exports.addressMatchPostRequestFromJSON = addressMatchPostRequestFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const addressmatchoptionsv1_js_1 = require("./addressmatchoptionsv1.js");
/** @internal */
exports.Options$inboundSchema = addressmatchoptionsv1_js_1.AddressMatchOptionsV1$inboundSchema;
/** @internal */
exports.Options$outboundSchema = addressmatchoptionsv1_js_1.AddressMatchOptionsV1$outboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Options$;
(function (Options$) {
    /** @deprecated use `Options$inboundSchema` instead. */
    Options$.inboundSchema = exports.Options$inboundSchema;
    /** @deprecated use `Options$outboundSchema` instead. */
    Options$.outboundSchema = exports.Options$outboundSchema;
})(Options$ || (exports.Options$ = Options$ = {}));
function optionsToJSON(options) {
    return JSON.stringify(exports.Options$outboundSchema.parse(options));
}
function optionsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Options$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Options' from JSON`);
}
/** @internal */
exports.AddressMatchPostRequest$inboundSchema = z.object({
    address: z.string(),
    options: z.nullable(addressmatchoptionsv1_js_1.AddressMatchOptionsV1$inboundSchema).optional(),
    postcode: z.string(),
});
/** @internal */
exports.AddressMatchPostRequest$outboundSchema = z.object({
    address: z.string(),
    options: z.nullable(addressmatchoptionsv1_js_1.AddressMatchOptionsV1$outboundSchema).optional(),
    postcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AddressMatchPostRequest$;
(function (AddressMatchPostRequest$) {
    /** @deprecated use `AddressMatchPostRequest$inboundSchema` instead. */
    AddressMatchPostRequest$.inboundSchema = exports.AddressMatchPostRequest$inboundSchema;
    /** @deprecated use `AddressMatchPostRequest$outboundSchema` instead. */
    AddressMatchPostRequest$.outboundSchema = exports.AddressMatchPostRequest$outboundSchema;
})(AddressMatchPostRequest$ || (exports.AddressMatchPostRequest$ = AddressMatchPostRequest$ = {}));
function addressMatchPostRequestToJSON(addressMatchPostRequest) {
    return JSON.stringify(exports.AddressMatchPostRequest$outboundSchema.parse(addressMatchPostRequest));
}
function addressMatchPostRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AddressMatchPostRequest$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AddressMatchPostRequest' from JSON`);
}
//# sourceMappingURL=addressmatchpostrequest.js.map